import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import LoginPage from './components/LoginPage';
import KamenyPage from './components/KamenyPage';
import SperkyPage from './components/SperkyPage';
import MaterialyPage from './components/MaterialyPage';
import ZmenaHeslaPage from './components/ZmenaHeslaPage';
import ObjednavkyPage from './components/ObjednavkyPage';

function AppRoutes() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route 
        path="/login" 
        element={isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />} 
      />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Navigate to="/kameny" replace />} />
                <Route path="/kameny" element={<KamenyPage />} />
                <Route path="/sperky" element={<SperkyPage />} />
                <Route path="/materialy" element={<MaterialyPage />} />
                <Route path="/objednavky" element={<ObjednavkyPage />} />
                <Route path="/zmena-hesla" element={<ZmenaHeslaPage />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
